import { merge } from "theme-ui";

import { svg } from "config/svgStyles";

export const modalContainer = ({ isDesktop }) =>
  merge(
    {
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 3000,
      background: "background",
      overflow: isDesktop ? "hidden" : "auto",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    },

    !isDesktop && {
      px: "20px",
      py: "40px",
    }
  );

export const modalContainerScroll = ({ isDesktop }) =>
  merge(
    {
      width: "100%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    },

    isDesktop && {
      py: "104px",
      overflow: "auto",
      height: "100%",
    }
  );

export const logos = {
  position: "absolute",
  top: "40px",
  left: "40px",
  zIndex: 100,
};

export const closeButton = ({ isDesktop }) =>
  merge(
    {
      color: "text",
      fontFamily: "body",
      fontWeight: "body",
      fontSize: "20px",
      lineHeight: "1",
      letterSpacing: "0.05em",
      textTransform: "uppercase",
      margin: "0 0 20px",

      svg: {
        marginLeft: isDesktop ? "0" : "10px",
        width: "20px",
        ...svg("text"),
      },

      "&:hover, &:focus": {
        color: "primary",

        svg: {
          ...svg("primary"),
        },
      },
    },

    isDesktop && {
      margin: "0",
      position: "absolute",
      top: "103px",
      right: "40px",
      zIndex: 100,
    }
  );

export const modal = ({ isFullWidth }) => ({
  color: "text",
  width: "100%",
  maxWidth: isFullWidth ? "100%" : "670px",
  position: "relative",
  zIndex: 200,
});

export const modalTitle = {
  background: "text",
  borderRadius: "8px 8px 0px 0px",
  color: "background",
  textAlign: "center",
  textTransform: "uppercase",
  padding: "25px 30px",
};

export const modalSubtitle = {
  background: "grey9",
  padding: "20px",
  textAlign: "center",
  textTransform: "uppercase",
};

export const modalContent = {
  background: "background",
  border: "solid 1px",
  borderTop: "none",
  borderBottomWidth: "0",
  borderColor: "grey9",

  "&:last-of-type": {
    borderBottomWidth: "1px",
    borderRadius: "0 0 8px 8px",
  },
};

export const contentText = {
  mx: "40px",
  py: "40px",
  borderTop: "solid 1px",
  borderColor: "grey9",
};
